import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Section, SectionHeading, iconMap } from './shared';
const services = [{
  title: 'Car or road accident',
  description: 'Drivers, passengers, riders, cyclists and pedestrians injured on WA roads.',
  link: '/car-accident-lawyers-perth/',
  icon: 'road',
  cta: 'Check a Road Accident Claim',
  featured: true
}, {
  title: 'Work injury',
  description: "Workers' compensation and common-law claims, including FIFO and construction injuries.",
  link: '/workers-compensation-lawyers-perth/',
  icon: 'work',
  cta: 'Explore Work Injury Claims'
}, {
  title: 'Public place injury',
  description: 'Slips, falls, dog attacks and injuries on premises owned or managed by others.',
  link: '/public-liability-lawyers-perth/',
  icon: 'public',
  cta: 'Explore Public Liability'
}, {
  title: 'Serious injury',
  description: 'Support for individuals and families facing life-changing injury and long-term needs.',
  link: '/catastrophic-injury-lawyers-perth/',
  icon: 'serious',
  cta: 'Explore Serious Injury Claims'
}, {
  title: 'Existing claim or insurer offer',
  description: 'Get a clear second opinion on an offer, strategy or how your claim is being handled.',
  link: '#compensation-calculator',
  icon: 'review',
  cta: 'Review My Existing Claim'
}, {
  title: 'Not sure where to start',
  description: 'Tell us what happened in plain English and we will help identify the right next step.',
  link: '#compensation-calculator',
  icon: 'unsure',
  cta: 'Help Me Choose'
}];
export function ClaimRouter() {
  return <Section id="claim-router" className="bg-canvas" data-id="element-142" data-mp="164xzvwqb0ji4">
      <SectionHeading eyebrow="Choose your situation" title="How Were You Injured?" intro="Start with the closest match. If none feels exact, choose 'Not sure' and we will help you work it out." align="center" data-id="element-143" data-mp="166it9j0vtwee" />

      <ul className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-144" data-mp="3jnub76hqzp4t">
        {services.map(service => {
        const Icon = iconMap[service.icon];
        return <li key={service.title} className="h-full" data-id="element-145" data-mp="3amw42fc0j1i0">
              <a href={service.link} className={`group flex h-full flex-col rounded-card border p-6 shadow-card transition-[transform,box-shadow,border-color] duration-200 ease-out hover:-translate-y-1 hover:shadow-card-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal ${service.featured ? 'border-forest/20 bg-forest text-paper' : 'border-ink/5 bg-paper text-ink'}`} data-id="element-146" data-mp="3ao7akmwuenct">
                <span className={`inline-flex h-11 w-11 items-center justify-center rounded-btn ${service.featured ? 'bg-paper/12 text-gold-light' : 'bg-warm-tint text-forest group-hover:bg-forest group-hover:text-paper'}`} data-id="element-147" data-mp="29717a5du3ef">
                  <Icon className="h-5 w-5" aria-hidden="true" strokeWidth={1.5} data-id="element-148" data-mp="2af8vw44lg2gc" />
                </span>
                <h3 className="mt-4 text-[19px] font-semibold leading-[1.3] md:min-h-[50px]" data-id="element-149" data-mp="2oeqo6th3lxug">
                  {service.title}
                </h3>
                <p className={`mt-2 flex-1 text-[16px] leading-[1.55] ${service.featured ? 'text-paper/75' : 'text-slate'}`} data-id="element-150" data-mp="2jdb2cz73jnb0">
                  {service.description}
                </p>
                <span className={`mt-5 inline-flex items-center gap-2 text-[16px] font-semibold leading-snug ${service.featured ? 'text-gold-light' : 'text-signal'}`} data-id="element-151" data-mp="25go4mu7bkt41">
                  {service.cta}
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-152" data-mp="180s61ri4dy81" />
                </span>
              </a>
            </li>;
      })}
      </ul>
    </Section>;
}